import BnttonInvalid from './src/main'

BnttonInvalid.install = function (Vue) {
    Vue.components(BnttonInvalid.name, BnttonInvalid)
}

export default BnttonInvalid